import PersonaOfficeShell from "@/components/PersonaOfficeShell";
import { Globe2, Film, Globe, IdCard, Calendar, Users, Search, Send } from "lucide-react";

/**
 * L13 · Sales Agent dashboard.
 *
 * Same layer as Distributor but different business — Sales Agents
 * pitch a film's rights to distributors worldwide, working the
 * festival + market circuit (Cannes, TIFF, EFM, AFM, Busan, Film Bazaar).
 *
 * Phase 1: catalogue + distributor discovery.
 * Phase 2 (roadmap): screener room, deal ledger, MG/expense
 * recoupment waterfall, festival strategy per title.
 */
const CONFIG = {
  layer:           "L13",
  label:           "Sales Agent",
  testidPrefix:    "sales-agent-office",
  accent:          "#DB6D19",
  Icon:            Globe2,
  expectedOrgType: "sales_agent",
  blurb:           "Sell rights territory by territory. Manage your slate, pitch distributors, work the international markets.",
  tiles: [
    {
      key: "catalogue", to: "/sales-agent/deals", TileIcon: Film,
      title: "Deals Ledger",
      desc:  "Every rights sale — territory, MG, commission split, delivery status.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "discovery", to: "/slate/discovery", TileIcon: Search,
      title: "Films on the Market",
      desc:  "Every film every distributor is licensing — find fresh territories to pitch.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "distributors", to: "/directory/orgs?type=distributor", TileIcon: Send,
      title: "Distributor Directory",
      desc:  "Every verified distributor — pitch territory by territory, window by window.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "markets", TileIcon: Calendar,
      title: "Market Calendar",
      desc:  "Cannes · Berlin · AFM · TIFF · Busan · Film Bazaar — your yearly circuit.",
      chip: "Soon", chipTone: "soon",
    },
    {
      key: "producers", to: "/directory/orgs?type=production_house", TileIcon: Search,
      title: "Production Houses",
      desc:  "Every verified producer on Call·Sheet — pitch representation on their slate.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "public-profile", to: "/office/public-profile", TileIcon: Globe,
      title: "Public Profile",
      desc:  "Your sales agency — territories, catalogue highlights, market participation.",
      chip: "Live", chipTone: "live",
    },
    {
      key: "icard", to: "/icard", TileIcon: IdCard,
      title: "Owner iCard",
      desc:  "Your verified, co-branded identity card.",
      chip: "Live", chipTone: "live",
    },
  ],
};

export default function SalesAgentDashboard() {
  return <PersonaOfficeShell config={CONFIG} />;
}
